// extracted by mini-css-extract-plugin
export var action = "styles-module--action--d16a2";
export var error = "styles-module--error--23a60";
export var image = "styles-module--image--8682b";
export var innerContainer = "styles-module--innerContainer--6f291";
export var innerContainerText = "styles-module--innerContainerText--cbea8";
export var outerContainer = "styles-module--outerContainer--5d027";
export var submitError = "styles-module--submitError--3be06";
export var submitErrorMessage = "styles-module--submitErrorMessage--77e8b";